import { render } from "./PowerOnBoot.vue?vue&type=template&id=0ff2983f"
import script from "./PowerOnBoot.vue?vue&type=script&lang=js"
export * from "./PowerOnBoot.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__